import JwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';

import { JWTToken } from '../../types/authentication';

type SavedJWT = {
  token: string;
  data: JWTToken;
};

const { BASE_DOMAIN } = process.env;
const JWT_COOKIE_KEY = 'token';

/**
 * Decodes JWT value to object.
 *
 * @param {String} token - given JWT value.
 * @return {JWTToken} object if success, otherwise exception will be thrown.
 */
export const decodeJWT = (token: string): JWTToken => JwtDecode(token);

/**
 * Getting saved token value from cookies.
 *
 * @param {Boolean} remove - do remove given key, true if needs to be remove otherwise false.
 */
export const getSavedJWT = (remove?: boolean): SavedJWT | null => {
  const cookie = Cookies.get();
  const token = cookie[JWT_COOKIE_KEY] || '';

  if (remove) {
    // REMOVE PROD TOKEN
    Cookies.set(JWT_COOKIE_KEY, '', {
      domain: `.${BASE_DOMAIN}`,
      path: '/',
      expires: 0,
    });

    // REMOVE TESTING TOKEN
    Cookies.set(JWT_COOKIE_KEY, '', {
      domain: `pre-www.${BASE_DOMAIN}`,
      path: '/',
      expires: 0,
    });
  }

  try {
    const data = decodeJWT(token);

    return {
      token,
      data,
    };
  } catch (errors) {
    return null;
  }
};
